import PropTypes from 'prop-types'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import { alpha, useTheme } from '@mui/material/styles'

CardBase.propTypes = {
  /** Left border color */
  color: PropTypes.string,

  /** Override color with red when urgent */
  urgent: PropTypes.bool,

  /** The accent is shortened to a small top-left tab instead of running the full height */
  short: PropTypes.bool,

  /** Whether the card is flagged */
  flagged: PropTypes.bool,

  /** Whether the card is selected */
  selected: PropTypes.bool,

  /** Callback when card is clicked */
  onClick: PropTypes.func,

  /** Card content */
  children: PropTypes.node,
}

export default function CardBase({ color, urgent = false, short = false, flagged = false, selected = false, onClick, children }) {
  const accent = urgent ? 'error.main' : color

  return (
    <Container selected={selected} flagged={flagged} onClick={onClick} borderColor={short ? null : accent}>
      {short && <Box sx={[styles.shortAccent, { backgroundColor: accent || 'transparent' }]} />}
      {children}
    </Container>
  )
}

CardBase.Loading = function ({ children, short = false }) {
  return (
    <Container borderColor={short ? null : 'divider'}>
      {short && <Box sx={[styles.shortAccent, { backgroundColor: 'divider' }]} />}
      {children}
    </Container>
  )
}

function Container({ selected, flagged, onClick, borderColor, children }) {
  const theme = useTheme()

  let backgroundColor
  if (selected) backgroundColor = theme.palette.mode === 'dark' ? theme.palette.primary.lighter : alpha(theme.palette.primary.main, 0.1)
  if (flagged) backgroundColor = 'warning.lighter'

  return (
    <Card
      sx={[
        styles.container,
        {
          backgroundColor,
          borderLeft: borderColor ? 6 : 0,
          borderLeftStyle: 'solid',
          borderLeftColor: borderColor || 'transparent',
        },
      ]}
    >
      <CardActionArea onClick={onClick} sx={styles.content}>
        {children}
      </CardActionArea>
    </Card>
  )
}

const styles = {
  container: {
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    transition: 'background-color 100ms linear',
  },
  content: {
    p: 1,
    pl: 1.5,
  },
  shortAccent: {
    position: 'absolute',
    left: 0,
    top: 8,
    width: 6,
    height: 24,
    borderTopRightRadius: 2,
    borderBottomRightRadius: 2,
  },
}
